import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import { ScanBarcode } from "iconsax-react";
import { blue } from "@mui/material/colors";

export default function LotsTableAssignedActions({ lot, fetchLots }) {

  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadPDFClick = () => {
    if(isLoading) { return; }
    setIsLoading(true);

    const link = document.createElement('a');
    link.href = lot.s3_qrcode;
    link.setAttribute('target', '_blank');
    link.download = 'GuíaCódigoQR.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setIsLoading(false);
  }

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >

      <IconButton
        size="small"
        color="primary"
        aria-label="Open / Download QR code"
        onClick={() => handleDownloadPDFClick()}
        style={{
          color: blue[400],
          backgroundColor: alpha(blue[500], 0.1),
        }}
      >
        <ScanBarcode fontSize="small" />
      </IconButton>
    </Stack>
  );
}
